import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  saveUserEmailAction,
  saveUserNameAction
} from "actions/user-settings-actions";
import { UserNameAndEmailSettings } from "components/settings/user-name-and-email-settings";
import { Loading } from "components/common/loading";

const UserNameAndEmailPage = (props) => {
  if (props.isLoading) {
    return <Loading />;
  }
  return (
    <UserNameAndEmailSettings { ...props } />
  );
};

UserNameAndEmailPage.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  confirmEmail: state.userSettings.confirmEmail,
  email: state.userSettings.email,
  firstName: state.userSettings.name,
  isLoading: state.userSettings.isUserNameLoading,
  lastName: state.userSettings.surname,
  newEmail: state.userSettings.newEmail
});

const mapDispatchToProps = (dispatch) => ({
  onSaveUserEmail: (userDetails) => dispatch(saveUserEmailAction(userDetails)),
  onSaveUserName: (userDetails) => dispatch(saveUserNameAction(userDetails))
});

export const UserNameAndEmailContainer = connect(mapStateToProps, mapDispatchToProps)(UserNameAndEmailPage);



// WEBPACK FOOTER //
// ./src/js/containers/settings/user-name-and-email-container.jsx